import Vue from 'vue'
import VueRouter from 'vue-router'
import OAuthLogin from '../views/OAuthLogin.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'OAuthLogin',
    component: OAuthLogin
  },
  {
    path: '/kimmu/:kimmuBi?',
    name: 'KimmuJisseki',
    component: () => import('../views/KimmuJisseki.vue')
  },
  {
    path: '/kimmuK/:kimmuBi?/:shainId?',
    name: 'KimmuJissekiK',
    component: () => import('../views/KimmuJissekiK.vue')
  },
  {
    path: '/gyomu/:nengetsu?/:shainId?',
    name: 'GyomuHokoku',
    component: () => import('../views/GyomuHokoku.vue')
  },
  {
    path: '/gyomuK/:nengetsu?/:shainId?',
    name: 'GyomuHokokuK',
    component: () => import('../views/GyomuHokokuK.vue')
  },
  {
    path: '/shuho/:torokuBi?',
    name: 'ShujiHokoku',
    component: () => import('../views/ShujiHokoku.vue')
  },
  {
    path: '/shain',
    name: 'ShainSettei',
    component: () => import('../views/ShainSettei.vue')
  },
  {
    path: '/shainK',
    name: 'ShainSetteiK',
    component: () => import('../views/ShainSetteiK.vue')
  },
  {
    path: '/jokyo',
    name: 'JokyoShokai',
    component: () => import('../views/JokyoShokai.vue')
  },
  {
    path: '/shokai',
    name: 'ShuhoShokai',
    component: () => import('../views/ShuhoShokai.vue')
  },
  {
    path: '/kintai',
    name: 'KintaiTodokeShokai',
    component: () => import('../views/KintaiTodokeShokai.vue')
  },
  {
    path: '/errorPage',
    name: 'ErrorPage',
    component: () => import('../views/ErrorPage.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
